/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../_chunks/dep-e43cf21c.js';
import { _ as _defineProperty } from '../_chunks/dep-46de7b2e.js';
import { _ as _asyncToGenerator, r as regenerator } from '../_chunks/dep-e0370ebe.js';
import React, { useEffect } from 'react';
import classNames from 'classnames';
import { render, unmount } from '../_util/react-render.js';
import noop from '../_util/noop.js';
import { PlacementOffset } from './const.js';
import MessageComponent from './MessageComponent.js';
export { default } from './MessageComponent.js';
import { globalConfig, getMessageConfig, setGlobalConfig } from './config.js';
import { useMessageClass } from './useMessageClass.js';
import '../_chunks/dep-2acfafca.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-e9b62d1f.js';
import 'react-dom';
import './MessageClose.js';
import 'tdesign-icons-react';
import '../hooks/useGlobalIcon.js';
import '../hooks/useConfig.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-f10515e8.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-88cd50bf.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-7dce2c26.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import './MessageIcon.js';
import '../loading/index.js';
import '../loading/Loading.js';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-6c5254c6.js';
import '../_util/easing.js';
import '../common/Portal.js';
import '../loading/gradient.js';
import '../hooks/useDomRefCallback.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-fd3498b6.js';
import '../_chunks/dep-92728dc5.js';
import '../_chunks/dep-ec16db36.js';
import '../_chunks/dep-036ad2cc.js';
import '../_chunks/dep-0e15088f.js';
import '../loading/defaultProps.js';
import '../loading/plugin.js';
import '../loading/style/css.js';
import '../loading/type.js';
import '../_util/usePersistFn.js';
import './defaultProps.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var MessageList = [];
var keyIndex = 1;
var MessageContainer = function MessageContainer(props) {
  var placement = props.placement,
    children = props.children,
    zIndex = props.zIndex,
    id = props.id,
    renderCallback = props.renderCallback;
  var style = {
    zIndex: zIndex
  };
  Object.keys(PlacementOffset[placement]).forEach(function (key) {
    style[key] = PlacementOffset[placement][key];
  });
  if (placement.includes("top")) {
    style.top = "".concat(globalConfig.top, "px");
  }
  useEffect(function () {
    renderCallback();
  }, []);
  var _useMessageClass = useMessageClass(),
    tdMessagePlacementClassGenerator = _useMessageClass.tdMessagePlacementClassGenerator,
    tdMessageListClass = _useMessageClass.tdMessageListClass;
  return /* @__PURE__ */React.createElement("div", {
    className: classNames(tdMessageListClass, tdMessagePlacementClassGenerator(placement)),
    style: style,
    id: id
  }, children);
};
function createContainer(_ref) {
  var attach = _ref.attach,
    zIndex = _ref.zIndex,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? "top" : _ref$placement;
  return new Promise(function (resolve) {
    var mountedDom = document.body;
    if (typeof attach === "string") {
      var result = document.querySelectorAll(attach);
      if (result.length >= 1) {
        mountedDom = result[0];
      }
    } else if (typeof attach === "function") {
      mountedDom = attach();
    }
    var containerId = "tdesign-message-container--".concat(placement);
    var container = Array.from(mountedDom.querySelectorAll("#".concat(containerId)));
    if (container.length < 1) {
      var div = document.createElement("div");
      render( /* @__PURE__ */React.createElement(MessageContainer, {
        id: containerId,
        placement: placement,
        zIndex: zIndex,
        renderCallback: function renderCallback() {
          mountedDom.appendChild(div);
          var container2 = Array.from(mountedDom.querySelectorAll("#".concat(containerId)));
          resolve(container2[0]);
        }
      }), div);
    } else {
      resolve(container[0]);
    }
  });
}
function renderElement(_x, _x2) {
  return _renderElement.apply(this, arguments);
}
function _renderElement() {
  _renderElement = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(theme, config) {
    var container, content, offset, _config$onClose, _onClose, div, message, style, _offset, left, top;
    return regenerator.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return createContainer(config);
        case 2:
          container = _context.sent;
          content = config.content, offset = config.offset, _config$onClose = config.onClose, _onClose = _config$onClose === void 0 ? noop : _config$onClose;
          div = document.createElement("div");
          keyIndex += 1;
          message = {
            close: function close() {
              unmount(div);
              div.remove();
              message.closed = true;
            },
            key: keyIndex,
            closed: false
          };
          style = _objectSpread({}, config.style);
          if (Array.isArray(offset) && offset.length === 2) {
            _offset = _slicedToArray(offset, 2), left = _offset[0], top = _offset[1];
            style = _objectSpread(_objectSpread({
              left: left,
              top: top
            }, style), {}, {
              position: "relative"
            });
          }
          return _context.abrupt("return", new Promise(function (resolve) {
            render( /* @__PURE__ */React.createElement(MessageComponent, _objectSpread(_objectSpread({
              key: keyIndex
            }, config), {}, {
              theme: theme,
              style: style,
              onClose: function onClose(ctx) {
                _onClose(ctx);
                message.close();
              }
            }), content), div);
            container.appendChild(div);
            MessageList.push(message);
            resolve(message);
          }));
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _renderElement.apply(this, arguments);
}
function isConfig(content) {
  return Object.prototype.toString.call(content) === "[object Object]" && !!content.content;
}
var messageMethod = function messageMethod(theme, content, duration) {
  var config = {};
  if (isConfig(content)) {
    config = _objectSpread({
      duration: duration
    }, content);
  } else {
    config = {
      content: content,
      duration: duration
    };
  }
  return renderElement(theme, getMessageConfig(config));
};
var MessagePlugin = function MessagePlugin(theme, message, duration) {
  return messageMethod(theme, message, duration);
};
MessagePlugin.info = function (content, duration) {
  return messageMethod("info", content, duration);
};
MessagePlugin.error = function (content, duration) {
  return messageMethod("error", content, duration);
};
MessagePlugin.warning = function (content, duration) {
  return messageMethod("warning", content, duration);
};
MessagePlugin.success = function (content, duration) {
  return messageMethod("success", content, duration);
};
MessagePlugin.question = function (content, duration) {
  return messageMethod("question", content, duration);
};
MessagePlugin.loading = function (content, duration) {
  return messageMethod("loading", content, duration);
};
MessagePlugin.config = function (options) {
  return setGlobalConfig(options);
};
MessagePlugin.close = function (messageInstance) {
  messageInstance.then(function (instance) {
    return instance.close();
  });
};
MessagePlugin.closeAll = function () {
  MessageList.forEach(function (message) {
    typeof message.close === "function" && message.close();
  });
  MessageList = [];
  return;
};

export { MessagePlugin };
//# sourceMappingURL=Message.js.map
